<template>
  <div v-if="this.isCheckingSession" class="container-scroller auth-loading-screen">
    <div class="auth-loading-card">
      <div class="auth-loading-spinner"></div>
      <span>Validando sesion...</span>
    </div>
  </div>

  <div v-else-if="this.ready == false" class="container-scroller soft-login-bg">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0 w-100">
        <div class="row w-100 mx-0 justify-content-center">
          <div class="col-12 col-xl-10">
            <div class="soft-shell">
              <!-- Panel lateral decorativo -->
              <aside class="soft-sidebar d-none d-md-flex">
                <div class="soft-sidebar-top">
                  <div class="soft-logo-box">
                    <img
                      src="../../public/images/logo-mini.png"
                      alt="logo"
                      class="soft-logo-img"
                    />
                  </div>
                </div>

              </aside>

              <!-- Contenido principal -->
              <section class="soft-main">
                <div class="soft-topbar">
                  <div>
                    <p class="soft-breadcrumb">CREDI CORE</p>
                    <h2 class="soft-heading">Bienvenido de nuevo</h2>
                  </div>

                  <div class="soft-status-card">
                    <div class="soft-status-dot"></div>
                    <span>Sistema seguro</span>
                  </div>
                </div>

                <div class="soft-grid">
                  <!-- Formulario -->
                  <div class="soft-panel login-panel">
                    <div class="soft-panel-header">
                      <h3>Iniciar sesión</h3>
                      <span>Introduce tus datos para continuar</span>
                    </div>

                    <form-tag-login
                      @my-event="submitHandler"
                      name="myform"
                      event="my-event"
                      class="soft-form"
                    >
                      <div class="soft-input-block">
                        <label class="soft-label">Correo electrónico</label>
                        <div class="soft-input-wrap">
                          <span class="soft-input-icon">
                            <i class="mdi mdi-email-outline"></i>
                          </span>
                          <text-input
                            v-model="email"
                            type="email"
                            name="email"
                            placeholder="Ingrese su correo"
                            :required="true"
                            icon="user"
                          />
                        </div>
                      </div>

                      <div class="soft-input-block">
                        <label class="soft-label">Contraseña</label>
                        <div class="soft-input-wrap">
                          <span class="soft-input-icon">
                            <i class="mdi mdi-lock-outline"></i>
                          </span>
                          <text-input
                            v-model="password"
                            type="password"
                            name="password"
                            placeholder="Ingrese su contraseña"
                            :required="true"
                            icon="lock"
                          />
                        </div>
                      </div>

                      <div class="soft-actions">
                        <input
                          type="submit"
                          class="btn soft-login-btn"
                          value="Iniciar Sesión"
                        />
                      </div>

                      <div class="soft-footer-links">
                        <a href="https://axum.hn" class="soft-link">Ir a Página Web</a>
                      </div>
                    </form-tag-login>
                  </div>

                  <!-- Panel informativo -->
                  <div class="soft-panel info-panel">
                    <div class="info-image-wrap">
                      <img src="@/assets/fondo-login.jpg" alt="Fondo de login" />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="container-scroller">
    <header-app />

    <div class="container-fluid page-body-wrapper">
      <NavbarLate />

      <router-view v-slot="{ Component }" :key="componentKey" @forceUpdate="forceUpdate">
        <component :is="Component"></component>
      </router-view>
    </div>
  </div>
</template>

<script>
import { store } from "./store.js";
import router from "./../router/index.js";
import Security from "./security.js";
import TextInput from "./forms/Text-Input-Login.vue";
import FormTagLogin from "./forms/FormTagLogin.vue";
import DashboardApp from "./../components/Body-App.vue";
import HeaderApp from "./../components/Header-App.vue";
import NavbarLate from "./../components/Navbar-Lateral.vue";
import Swal from "sweetalert2";

export default {
  name: "LoginApp",
  data() {
    return {
      email: "",
      password: "",
      store,
      componentKey: 0,
      ready: false,
      isCheckingSession: true,
    };
  },
  components: {
    TextInput,
    FormTagLogin,
    DashboardApp,
    HeaderApp,
    NavbarLate,
  },
  beforeMount() {
    if (!Security.hydrateSessionFromCookie()) {
      this.ready = false;
      this.isCheckingSession = false;
      return;
    }

    const cookieData = Security.getUser()[0];

    store.token = cookieData.token.token;
    store.user = {
      id: cookieData.user.id,
      first_name: cookieData.user.first_name,
      last_name: cookieData.user.last_name,
      email: cookieData.user.email,
    };

    console.log(`This is the name en APP ${cookieData.user.first_name}`);

    Security.checkTokenValid()
      .then((valid) => {
        this.ready = valid !== false;
      })
      .finally(() => {
        this.isCheckingSession = false;
      });
  },
  methods: {
    forceUpdate() {
      this.componentKey += 1;
    },

    submitHandler() {
      const payload = {
        email: this.email,
        password: this.password,
      };

      fetch(process.env.VUE_APP_API_URL + "/users/login", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            Swal.fire({
              icon: "error",
              title: "Correo o Contraseña Incorrecta",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            const sessionData = Security.sanitizeAuthData(response.data);
            store.token = sessionData.token.token;

            store.user = {
              id: sessionData.user.id,
              first_name: sessionData.user.first_name,
              last_name: sessionData.user.last_name,
              email: sessionData.user.email,
              roles: sessionData.user.roles,
            };

            store.roles = sessionData.user.roles;

            console.log(sessionData.user.roles);
            console.log(store.roles);

            const date = new Date();
            date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
            const expires = "expires=" + date.toUTCString();

            Security.saveSessionData(sessionData, expires);

            router.push("/");
            location.reload();
          }
        });
    },
  },
};
</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
}

.auth-loading-screen {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  background: #f4f6fa;
}

.auth-loading-card {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #4d5d70;
  font-weight: 600;
}

.auth-loading-spinner {
  width: 26px;
  height: 26px;
  border: 3px solid rgba(77, 93, 112, 0.18);
  border-top-color: #4d5d70;
  border-radius: 50%;
  animation: auth-spin 0.8s linear infinite;
}

@keyframes auth-spin {
  to {
    transform: rotate(360deg);
  }
}

.soft-login-bg {
  min-height: 100dvh;
  height: 100dvh;
  background:
    radial-gradient(
      circle at top left,
      rgba(255, 255, 255, 0.9),
      rgba(236, 242, 248, 0.75) 30%,
      transparent 55%
    ),
    linear-gradient(180deg, #edf3f8 0%, #e8eef4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  overflow: hidden;
}

.soft-login-bg .page-body-wrapper.full-page-wrapper,
.soft-login-bg .content-wrapper,
.soft-login-bg .row,
.soft-login-bg .col-12.col-xl-10,
.soft-shell,
.soft-main,
.soft-grid,
.soft-panel,
.login-panel,
.info-panel,
.info-image-wrap {
  min-width: 0;
  min-height: 0;
}

.soft-login-bg .page-body-wrapper.full-page-wrapper,
.soft-login-bg .content-wrapper,
.soft-login-bg .row,
.soft-login-bg .col-12.col-xl-10 {
  height: 100%;
}

.soft-shell {
  width: 100%;
  height: 100%;
  max-height: 100%;
  background: rgba(240, 245, 250, 0.9);
  border-radius: 34px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow:
    18px 18px 40px rgba(163, 177, 198, 0.22),
    -12px -12px 30px rgba(255, 255, 255, 0.75),
    inset 1px 1px 0 rgba(255, 255, 255, 0.55);
  display: flex;
  overflow: hidden;
  backdrop-filter: blur(8px);
}

.soft-sidebar {
  width: 82px;
  min-width: 82px;
  background: linear-gradient(
    180deg,
    rgba(245, 248, 251, 0.92) 0%,
    rgba(236, 242, 247, 0.92) 100%
  );
  border-right: 1px solid rgba(255, 255, 255, 0.7);
  padding: 18px 12px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  display: flex;
  overflow: hidden;
}

.soft-sidebar-top {
  width: 100%;
  display: flex;
  justify-content: center;
}

.soft-logo-box {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: #eaf0f5;
  display: grid;
  place-items: center;
  box-shadow:
    8px 8px 18px rgba(163, 177, 198, 0.22),
    -8px -8px 18px rgba(255, 255, 255, 0.8);
}

.soft-logo-img {
  width: 58%;
  height: auto;
  object-fit: contain;
}

.soft-sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
}

.soft-side-icon {
  width: 46px;
  height: 46px;
  border-radius: 15px;
  display: grid;
  place-items: center;
  color: #6e7d90;
  font-size: 20px;
  background: transparent;
  transition: all 0.2s ease;
}

.soft-side-icon.active {
  background: rgba(221, 229, 238, 0.95);
  box-shadow:
    inset 5px 5px 10px rgba(184, 198, 214, 0.4),
    inset -5px -5px 10px rgba(255, 255, 255, 0.75);
  color: #41536d;
}

.soft-main {
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 20px 22px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.soft-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.soft-breadcrumb {
  margin: 0 0 2px;
  font-size: 0.82rem;
  color: #8a98ab;
  letter-spacing: 0.04em;
}

.soft-heading {
  margin: 0;
  font-size: clamp(1.35rem, 1.8vw, 1.85rem);
  font-weight: 700;
  color: #1f2b3d;
  line-height: 1.15;
}

.soft-status-card {
  min-height: 42px;
  padding: 0 16px;
  border-radius: 14px;
  background: rgba(244, 248, 252, 0.85);
  box-shadow:
    8px 8px 18px rgba(163, 177, 198, 0.16),
    -8px -8px 18px rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  gap: 10px;
  color: #5f6f84;
  font-weight: 600;
  font-size: 0.92rem;
}

.soft-status-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #60c48d;
  box-shadow: 0 0 0 5px rgba(96, 196, 141, 0.12);
}

.soft-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  gap: 18px;
  align-items: stretch;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.soft-panel {
  background: rgba(236, 242, 247, 0.75);
  border-radius: 24px;
  box-shadow:
    inset 1px 1px 0 rgba(255, 255, 255, 0.7),
    10px 10px 24px rgba(163, 177, 198, 0.16),
    -10px -10px 24px rgba(255, 255, 255, 0.72);
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.login-panel {
  order: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.info-panel {
  order: 1;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  overflow: hidden;
}

.info-image-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 24px;
}

.info-image-wrap img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.soft-panel-header {
  margin-bottom: 16px;
  width: 100%;
}

.login-panel .soft-panel-header {
  max-width: 420px;
  text-align: center;
}

.soft-panel-header h3 {
  margin: 0;
  font-size: clamp(1.2rem, 1.5vw, 1.7rem);
  font-weight: 700;
  color: #202d40;
  line-height: 1.15;
}

.soft-panel-header span {
  display: inline-block;
  margin-top: 4px;
  color: #8491a3;
  font-size: 0.88rem;
  line-height: 1.4;
}

.soft-form {
  width: 100%;
  max-width: 420px;
  margin-top: 4px;
}

.soft-input-block {
  margin-bottom: 16px;
}

.soft-label {
  display: block;
  margin-bottom: 8px;
  color: #49596d;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: left;
}

.soft-input-wrap {
  position: relative;
}

.soft-input-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #7e8d9f;
  font-size: 18px;
  z-index: 2;
  pointer-events: none;
}

.soft-input-wrap :deep(input),
.soft-input-wrap :deep(.form-control),
.soft-input-wrap :deep(input.form-control) {
  width: 100%;
  min-height: 52px;
  border: none !important;
  outline: none !important;
  border-radius: 16px !important;
  background: rgba(244, 248, 252, 0.95) !important;
  box-shadow:
    inset 5px 5px 12px rgba(192, 203, 214, 0.42),
    inset -5px -5px 12px rgba(255, 255, 255, 0.9) !important;
  padding-left: 50px !important;
  padding-right: 16px !important;
  color: #233247 !important;
  font-size: 0.95rem;
}

.soft-input-wrap :deep(input::placeholder),
.soft-input-wrap :deep(.form-control::placeholder) {
  color: #9aa6b5 !important;
}

.soft-input-wrap :deep(input:focus),
.soft-input-wrap :deep(.form-control:focus) {
  box-shadow:
    inset 4px 4px 10px rgba(192, 203, 214, 0.46),
    inset -4px -4px 10px rgba(255, 255, 255, 0.95),
    0 0 0 3px rgba(71, 105, 155, 0.08) !important;
}

.soft-actions {
  margin-top: 18px;
}

.soft-login-btn {
  width: 100%;
  min-height: 50px;
  border: none;
  border-radius: 16px;
  /* background: linear-gradient(180deg, #1b2a56 0%, #152246 100%); */
  background: black;
  color: #fff;
  font-weight: 700;
  font-size: 0.96rem;
  letter-spacing: 0.02em;
  box-shadow:
    10px 10px 20px rgba(163, 177, 198, 0.24),
    -6px -6px 16px rgba(255, 255, 255, 0.7);
  transition: all 0.2s ease;
}

.soft-login-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.03);
  color: #fff;
}

.soft-login-btn:active {
  transform: translateY(0);
  box-shadow:
    inset 6px 6px 14px rgba(13, 24, 54, 0.32),
    inset -4px -4px 12px rgba(70, 94, 145, 0.15);
}

.soft-footer-links {
  margin-top: 14px;
  text-align: center;
}

.soft-link {
  color: #7e8ea1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
}

.soft-link:hover {
  color: #1f315e;
  text-decoration: none;
}

/* laptop con poca altura */
@media (min-width: 1200px) and (max-height: 860px) {
  .soft-main {
    padding: 16px 18px;
  }

  .soft-topbar {
    margin-bottom: 12px;
  }

  .soft-panel {
    border-radius: 20px;
  }

  .login-panel {
    padding: 14px;
  }

  .soft-panel-header {
    margin-bottom: 10px;
  }

  .soft-panel-header h3 {
    font-size: 1.15rem;
  }

  .soft-panel-header span {
    font-size: 0.82rem;
  }

  .soft-input-block {
    margin-bottom: 12px;
  }

  .soft-input-wrap :deep(input),
  .soft-input-wrap :deep(.form-control),
  .soft-input-wrap :deep(input.form-control) {
    min-height: 48px;
  }

  .soft-login-btn {
    min-height: 46px;
  }
}

/* TABLET */
@media (max-width: 1199px) {
  .soft-login-bg {
    min-height: 100dvh;
    height: auto;
    overflow: visible;
  }

  .soft-login-bg .page-body-wrapper.full-page-wrapper,
  .soft-login-bg .content-wrapper,
  .soft-login-bg .row,
  .soft-login-bg .col-12.col-xl-10 {
    height: auto;
  }

  .soft-shell {
    height: auto;
    min-height: calc(100dvh - 24px);
  }

  .soft-main {
    height: auto;
    overflow: visible;
    padding: 24px;
  }

  .soft-grid {
    grid-template-columns: 1fr;
    overflow: visible;
  }

  .login-panel {
    order: 1;
  }

  .info-panel {
    order: 2;
    min-height: 280px;
  }

  .info-image-wrap {
    min-height: 280px;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .soft-login-bg {
    padding: 12px;
    align-items: stretch;
  }

  .soft-shell {
    border-radius: 24px;
    min-height: calc(100dvh - 24px);
  }

  .soft-main {
    padding: 18px;
  }

  .soft-topbar {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 18px;
  }

  .soft-heading {
    font-size: 1.5rem;
  }

  .soft-status-card {
    width: 100%;
    justify-content: flex-start;
  }

  .soft-panel {
    border-radius: 22px;
  }

  .login-panel {
    padding: 18px;
  }

  .login-panel .soft-panel-header {
    text-align: left;
    max-width: 100%;
  }

  .soft-form {
    max-width: 100%;
  }

  .soft-input-wrap :deep(input),
  .soft-input-wrap :deep(.form-control),
  .soft-input-wrap :deep(input.form-control) {
    min-height: 54px;
    font-size: 0.95rem;
  }

  .soft-login-btn {
    min-height: 54px;
  }

  .info-panel,
  .info-image-wrap {
    min-height: 220px;
  }
}

/* MOBILE PEQUEÑO */
@media (max-width: 480px) {
  .soft-login-bg {
    padding: 10px;
  }

  .soft-main {
    padding: 14px;
  }

  .login-panel {
    padding: 16px;
  }

  .soft-breadcrumb {
    font-size: 0.8rem;
  }

  .soft-heading {
    font-size: 1.35rem;
  }

  .soft-panel-header h3 {
    font-size: 1.25rem;
  }

  .soft-panel-header span {
    font-size: 0.88rem;
  }

  .soft-input-icon {
    left: 16px;
    font-size: 18px;
  }

  .soft-input-wrap :deep(input),
  .soft-input-wrap :deep(.form-control),
  .soft-input-wrap :deep(input.form-control) {
    padding-left: 48px !important;
  }
}
</style>
